export default "__VITE_ASSET__fCFrl1ik__"